import React from 'react';

interface IQosErrorBoundaryProps {
  readonly onCatch: (error: unknown) => void;
}

interface IQosErrorBoundaryState {
  readonly hasError: boolean;
  readonly error: unknown;
}

/**
 * The error boundary that catches the error. It will re-throw the caught error to the consumer app of QosProvider.
 * It is the consumer's responsibility to handle the error.
 */
export class QosErrorBoundary extends React.Component<IQosErrorBoundaryProps, IQosErrorBoundaryState> {
  constructor(props: IQosErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  componentDidCatch(error: unknown, _errorInfo: unknown): void {
    this.props.onCatch(error);
    this.setState({ hasError: true, error });
  }

  render(): React.ReactNode {
    if (this.state.error !== null) {
      throw this.state.error;
    }
    return this.props.children;
  }
}
